{
  "name": "@prisma/engines-version",
  "version": "7.9.0-1.e922089b7d7502aff4249d5da3420f6fa55fc6ad",
  "main": "index.js",
  "types": "index.d.ts",
  "license": "Apache-2.0",
  "author": "Tim Suchanek <suchanek@prisma.io>",
  "prisma": {
    "enginesVersion": "e922089b7d7502aff4249d5da3420f6fa55fc6ad"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/prisma/engines-wrapper.git",
    "directory": "packages/engines-version"
  },
  "devDependencies": {
    "@types/node": "18.19.76",
    "typescript": "4.9.5"
  },
  "files": [
    "index.js",
    "index.d.ts"
  ],
  "scripts": {
    "build": "tsc -d"
  }
}